import ModalResponsive from '@/components/commons/modal-responsive';
import { formatIDR } from '@/lib/utils';
import { IProduct, IProductDetailPriceBook } from '@/types/product';
import React from 'react';

type ModalPricebookInformationProps = {
  openModal: boolean;
  setOpenModal: (open: boolean) => void;
  pricebookData?: IProductDetailPriceBook[];
  basePrice?: number;
  itemId?: string;
  parentData?: IProduct;
  filteredData?: IProductDetailPriceBook[];
};

export default function ModalPricebookInformation({
  openModal,
  setOpenModal,
  pricebookData = [],
  basePrice = 0,
  itemId = '',
  parentData,
  filteredData,
}: ModalPricebookInformationProps) {
  const filteredPricebook = filteredData || [];
  return (
    <>
      <ModalResponsive
        openModal={openModal}
        setOpenModal={setOpenModal}
        title='Tiered Pricing'
        className='theme_font z-[1000] max-w-md !rounded-none'
      >
        <div className='z-60 p-2 sm:p-4'>
          {pricebookData.length > 0 ? (
            <div className='max-h-[60vh] overflow-y-auto pr-2'>
              <div className='space-y-2 sm:space-y-3'>
                {filteredPricebook
                  .slice()
                  .sort((a, b) => a.min_unit - b.min_unit)
                  .map((item, index) => {
                    const currentBasePrice = itemId
                      ? basePrice
                      : parentData?.product_items?.find((pi) => pi.item_id === item.item_id)
                          ?.sell_price || 0;

                    const total = item.retail_price * item.min_unit;
                    const originalTotal = currentBasePrice * item.min_unit;
                    const saved = originalTotal - total;

                    return (
                      <div key={index} className='rounded-md border border-slate-400'>
                        <div className='grid grid-cols-2 p-1'>
                          <div className='flex flex-col p-1'>
                            <h1 className='font-semibold '>Total {formatIDR(total)}</h1>
                            <div className='flex flex-col gap-x-1 sm:flex-row sm:items-center'>
                              {saved > 0 && (
                                <h1 className='font-medium text-red-500 '>
                                  Saved {formatIDR(saved)}
                                </h1>
                              )}
                              <h1 className='text-slate-500 line-through'>
                                {formatIDR(originalTotal)}
                              </h1>
                            </div>
                          </div>
                          <div className='p-1 text-right'>
                            <h1 className='font-semibold text-green-500 '>
                              Buy {item.min_unit} or More
                            </h1>
                            <div className='flex flex-col gap-x-2 sm:flex-row sm:justify-end sm:text-right'>
                              <h1 className='order-1 font-medium sm:order-1'>
                                {formatIDR(item.retail_price)} / Each
                              </h1>
                              <h1 className='order-2 text-slate-500 line-through sm:order-2'>
                                {formatIDR(currentBasePrice)}
                              </h1>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          ) : (
            <div className='py-8 text-center'>
              <p className='text-gray-500'>No tiered pricing available</p>
            </div>
          )}
        </div>
      </ModalResponsive>
    </>
  );
}
